import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from "@angular/core";
import { SideDrawerComponent } from "../shell/side-drawer.component";
import {
  CrewCommandsStore,
  MAST_COMMANDS,
  MAST_LABELS,
  type MastCommandSpec,
  type MastState,
} from "../core/sim/crew-commands.store";

/**
 * Mast stepping / unstepping drawer for boats with a tabernacle
 * (Antila 27 etc.). Renders the linear MAST_COMMANDS checklist as
 * step buttons — top half lowers the spar (luzowanie fałów →
 * wyjęcie zawleczki sztagu → kładzenie na rufę), bottom half
 * reverses it.
 *
 * Each command stays disabled until the mast is in its valid `from`
 * state. The opening of the drawer is gated by `mastFoldable` at
 * the panel level, so users of boats without a foldable mast never
 * see it.
 */
@Component({
  selector: "po-mast-drawer",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SideDrawerComponent],
  templateUrl: "./mast-drawer.component.html",
  styleUrl: "./mast-drawer.component.css",
})
export class MastDrawerComponent {
  readonly open = input.required<boolean>();
  readonly anchorBottom = input<number>(64);
  readonly closeRequest = output<void>();

  readonly store = inject(CrewCommandsStore);

  readonly state = computed(() => this.store.mast());

  readonly lowerCommands: readonly MastCommandSpec[] = MAST_COMMANDS.filter(
    (c) =>
      c.id === "slacken_halyards" ||
      c.id === "free_forestay" ||
      c.id === "detach_boom" ||
      c.id === "lower_mast",
  );
  readonly raiseCommands: readonly MastCommandSpec[] = MAST_COMMANDS.filter(
    (c) =>
      c.id === "raise_mast" ||
      c.id === "attach_boom" ||
      c.id === "secure_forestay" ||
      c.id === "tension_halyards",
  );

  stateLabel(s: MastState): string {
    return MAST_LABELS[s];
  }

  canRun(commandId: string): boolean {
    return this.store.canCommandMast(commandId);
  }

  run(commandId: string): void {
    this.store.commandMast(commandId);
  }
}
